/**
 * Bundle Builder - Construtor de Kits Personalizados
 * Gerencia estado, navegação entre steps, preview em tempo real e adição ao carrinho
 */

class BundleBuilder {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    this.currentStep = 1;
    this.maxSteps = 4;
    
    // Estado do bundle
    this.bundle = {
      base: [], // [{ variantId, productId, product }]
      charms: [], // [{ variantId, productId, product }]
      additional: [] // [{ variantId, productId, product }]
    };



    const discount2 = parseFloat(container.dataset.discount2Charms) || parseFloat(container.getAttribute('data-discount-2-charms')) || 5;
    const discount3 = parseFloat(container.dataset.discount3Charms) || parseFloat(container.getAttribute('data-discount-3-charms')) || 10;
    const discount4 = parseFloat(container.dataset.discount4Charms) || parseFloat(container.getAttribute('data-discount-4-charms')) || 15;
    const discount5 = parseFloat(container.dataset.discount5Charms) || parseFloat(container.getAttribute('data-discount-5-charms')) || 0;
    const discount6 = parseFloat(container.dataset.discount6PlusCharms) || parseFloat(container.getAttribute('data-discount-6-plus-charms')) || 0;
    
    this.settings = {
      enableProgressiveDiscount: container.dataset.enableProgressiveDiscount === 'true',
      discounts: {
        2: discount2,
        3: discount3,
        4: discount4,
        5: discount5,
        6: discount6
      },
      minCharms: parseInt(container.dataset.minCharms) || 0,
      maxCharms: parseInt(container.dataset.maxCharms) || 0,
      pixDiscount: parseFloat(container.dataset.pixDiscount) || 5
    };

    this.init();
  }

  init() {
    this.cacheElements();
    this.bindEvents();
    this.updateStepper();
    this.updatePreview();
    this.updateStepActionsVisibility();
    
    if (this.previewContent && window.innerWidth < 1024) {
      this.previewContent.setAttribute('aria-hidden', 'false');
      if (this.previewToggle) {
        this.previewToggle.setAttribute('aria-expanded', 'true');
      }
    }
  }

  cacheElements() {
    this.stepsContainer = this.container.querySelector('[data-bundle-steps]');
    this.steps = this.stepsContainer.querySelectorAll('.custom-bundle-step');
    
    this.stepper = this.container.querySelector('[data-bundle-stepper]');
    this.stepperSteps = this.stepper?.querySelectorAll('[data-step-number]');
    
    this.preview = this.container.querySelector('[data-bundle-preview]');
    this.previewToggle = this.preview?.querySelector('[data-preview-toggle]');
    this.previewContent = this.preview?.querySelector('[data-preview-content]');
    
    this.baseGrid = this.container.querySelector('[data-base-grid]');
    this.baseItems = this.container.querySelectorAll('[data-base-item]');
    this.baseRadios = this.container.querySelectorAll('[data-base-item] input[type="checkbox"]');
    const step1Actions = this.container.querySelector('[data-step-actions="1"]');
    this.baseNextBtn = step1Actions ? step1Actions.querySelector('[data-step-next]') : null;
    
    this.charmsGrid = this.container.querySelector('[data-charms-grid]');
    this.charmsItems = this.container.querySelectorAll('[data-charm-item]');
    this.charmsCheckboxes = this.container.querySelectorAll('[data-charm-item] input[type="checkbox"]');
    this.charmsCounter = this.container.querySelector('[data-charms-counter]');
    this.charmsIncentive = this.container.querySelector('[data-charms-incentive]');
    const step2Actions = this.container.querySelector('[data-step-actions="2"]');
    this.charmsBackBtn = step2Actions ? step2Actions.querySelector('[data-step-back]') : null;
    this.charmsNextBtn = step2Actions ? step2Actions.querySelector('[data-step-next]') : null;
    
    this.additionalGrid = this.container.querySelector('[data-additional-grid]');
    this.additionalCheckboxes = this.container.querySelectorAll('[data-additional-item] input[type="checkbox"]');
    const step3Actions = this.container.querySelector('[data-step-actions="3"]');
    this.additionalBackBtn = step3Actions ? step3Actions.querySelector('[data-step-back]') : null;
    this.additionalSkipBtn = step3Actions ? step3Actions.querySelector('[data-step-skip]') : null;
    this.additionalNextBtn = step3Actions ? step3Actions.querySelector('[data-step-next]') : null;
    
    const step4Actions = this.container.querySelector('[data-step-actions="4"]');
    this.reviewBackBtn = step4Actions ? step4Actions.querySelector('[data-step-back]') : null;
    this.reviewAddBtn = this.container.querySelector('[data-add-to-cart]');
    this.shareBtn = step4Actions ? step4Actions.querySelector('[data-share-bundle]') : null;
    
    this.stepActionsContainers = {
      1: step1Actions,
      2: step2Actions,
      3: step3Actions,
      4: step4Actions
    };
    
    this.shareModal = this.container.querySelector('[data-share-modal]');
    this.shareModalClose = this.container.querySelectorAll('[data-share-modal-close]');
    this.shareLinkInput = this.container.querySelector('[data-share-link-input]');
    this.shareCopyBtn = this.container.querySelector('[data-share-copy-link]');
    this.shareWhatsAppBtn = this.container.querySelector('[data-share-whatsapp]');
    this.shareFacebookBtn = this.container.querySelector('[data-share-facebook]');
    this.shareTwitterBtn = this.container.querySelector('[data-share-twitter]');
  }

  bindEvents() {
    if (this.previewToggle) {
      this.previewToggle.addEventListener('click', () => {
        const isExpanded = this.previewContent.getAttribute('aria-hidden') !== 'false';
        this.previewContent.setAttribute('aria-hidden', !isExpanded);
        this.previewToggle.setAttribute('aria-expanded', isExpanded);
      });
    }

    if (this.baseRadios.length > 0) {
      this.baseRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
          if (e.target.checked) {
            this.addBase(e.target);
          } else {
            this.removeBase(e.target);
          }
        });
      });
    }

    if (this.baseNextBtn) {
      this.baseNextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.goToStep(2);
      });
    }

    if (this.charmsCheckboxes.length > 0) {
      this.charmsCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            this.addCharm(e.target);
          } else {
            this.removeCharm(e.target);
          }
        });
      });
    }

    if (this.charmsBackBtn) {
      this.charmsBackBtn.addEventListener('click', () => this.goToStep(1));
    }

    if (this.charmsNextBtn) {
      this.charmsNextBtn.addEventListener('click', () => this.goToStep(3));
    }

    if (this.additionalCheckboxes.length > 0) {
      this.additionalCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            this.addAdditional(e.target);
          } else {
            this.removeAdditional(e.target);
          }
        });
      });
    }

    if (this.additionalBackBtn) {
      this.additionalBackBtn.addEventListener('click', () => this.goToStep(2));
    }

    if (this.additionalSkipBtn) {
      this.additionalSkipBtn.addEventListener('click', () => this.goToStep(4));
    }

    if (this.additionalNextBtn) {
      this.additionalNextBtn.addEventListener('click', () => this.goToStep(4));
    }

    if (this.reviewBackBtn) {
      this.reviewBackBtn.addEventListener('click', () => this.goToStep(3));
    }

    if (this.reviewAddBtn) {
      this.reviewAddBtn.addEventListener('click', () => this.addToCart());
    }

    if (this.shareBtn) {
      this.shareBtn.addEventListener('click', () => this.openShareModal());
    }

    if (this.shareModalClose && this.shareModalClose.length > 0) {
      this.shareModalClose.forEach(btn => {
        btn.addEventListener('click', () => this.closeShareModal());
      });
    }

    if (this.shareCopyBtn) {
      this.shareCopyBtn.addEventListener('click', () => this.copyShareLink());
    }

    if (this.shareWhatsAppBtn) {
      this.shareWhatsAppBtn.addEventListener('click', () => this.shareOnWhatsApp());
    }

    if (this.shareFacebookBtn) {
      this.shareFacebookBtn.addEventListener('click', () => this.shareOnFacebook());
    }

    if (this.shareTwitterBtn) {
      this.shareTwitterBtn.addEventListener('click', () => this.shareOnTwitter());
    }

    this.restoreBundleFromURL();
  }

  async addBase(checkbox) {
    const item = checkbox.closest('[data-base-item]');
    const variantId = checkbox.value;
    const productId = item.dataset.productId;
    const productHandle = item.dataset.productHandle;

    if (this.bundle.base.some(b => b.variantId === variantId)) {
      return;
    }

    const productData = await this.fetchProductData(productHandle, variantId);
    if (productData) {
      this.bundle.base.push({
        variantId: variantId,
        productId: productId,
        productHandle: productHandle,
        product: productData
      });

      if (this.baseNextBtn) {
        this.baseNextBtn.disabled = false;
      }

      this.updatePreview();
    }
  }

  removeBase(checkbox) {
    const variantId = checkbox.value;
    this.bundle.base = this.bundle.base.filter(b => b.variantId !== variantId);

    if (this.baseNextBtn && this.bundle.base.length === 0) {
      this.baseNextBtn.disabled = true;
    }

    this.updatePreview();
  }

  async addCharm(checkbox) {
    if (this.settings.maxCharms > 0 && this.bundle.charms.length >= this.settings.maxCharms) {
      checkbox.checked = false;
      this.showMessage(`Você pode selecionar no máximo ${this.settings.maxCharms} charms.`, 'warning');
      return;
    }

    const item = checkbox.closest('[data-charm-item]');
    const variantId = checkbox.value;
    const productId = item.dataset.productId;
    const productHandle = item.dataset.productHandle;

    if (this.bundle.charms.some(c => c.variantId === variantId)) {
      return;
    }


    const productData = await this.fetchProductData(productHandle, variantId);
    if (productData) {
      this.bundle.charms.push({
        variantId: variantId,
        productId: productId,
        productHandle: productHandle,
        product: productData
      });

      this.updateCharmsCounter();
      this.updatePreview();
      this.updateIncentive();
    }
  }

  removeCharm(checkbox) {
    const variantId = checkbox.value;
    this.bundle.charms = this.bundle.charms.filter(c => c.variantId !== variantId);

    this.updateCharmsCounter();
    this.updatePreview();
    this.updateIncentive();
  }

  async addAdditional(checkbox) {
    const item = checkbox.closest('[data-additional-item]');
    const variantId = checkbox.value;
    const productId = item.dataset.productId;
    const productHandle = item.dataset.productHandle;

    // Verificar se já está selecionado
    if (this.bundle.additional.some(a => a.variantId === variantId)) {
      return;
    }

    // Buscar dados do produto
    const productData = await this.fetchProductData(productHandle, variantId);
    if (productData) {
      this.bundle.additional.push({
        variantId: variantId,
        productId: productId,
        productHandle: productHandle,
        product: productData
      });

      this.updatePreview();
    }
  }

  removeAdditional(checkbox) {
    const variantId = checkbox.value;
    this.bundle.additional = this.bundle.additional.filter(a => a.variantId !== variantId);

    this.updatePreview();
  }

  updateCharmsCounter() {
    if (this.charmsCounter) {
      const selected = this.bundle.charms.length;
      const valueEl = this.charmsCounter.querySelector('[data-charms-selected]');
      if (valueEl) {
        valueEl.textContent = selected;
      }
    }
  }

  updateIncentive() {
    if (!this.charmsIncentive) return;

    const selected = this.bundle.charms.length;
    const messageEl = this.charmsIncentive.querySelector('[data-incentive-message]');

    if (selected === 0) {
      this.charmsIncentive.style.display = 'none';
      return;
    }

    if (!this.settings.enableProgressiveDiscount) {
      this.charmsIncentive.style.display = 'none';
      return;
    }

    const currentDiscount = this.calculateDiscount(selected);
    const discounts = this.settings.discounts;

    // Encontrar o próximo nível de desconto disponível
    let nextDiscountLevel = null;
    let nextDiscountPercent = null;
    let charmesNeeded = 0;

    // Verificar cada nível de desconto
    if (selected < 2 && discounts[2] > 0) {
      nextDiscountLevel = 2;
      nextDiscountPercent = discounts[2];
      charmesNeeded = 2 - selected;
    } else if (selected < 3 && discounts[3] > currentDiscount) {
      nextDiscountLevel = 3;
      nextDiscountPercent = discounts[3];
      charmesNeeded = 3 - selected;
    } else if (selected < 4 && discounts[4] > currentDiscount) {
      nextDiscountLevel = 4;
      nextDiscountPercent = discounts[4];
      charmesNeeded = 4 - selected;
    } else if (selected < 5 && discounts[5] > 0 && discounts[5] > currentDiscount) {
      nextDiscountLevel = 5;
      nextDiscountPercent = discounts[5];
      charmesNeeded = 5 - selected;
    } else if (selected < 6 && discounts[6] > 0 && discounts[6] > currentDiscount) {
      nextDiscountLevel = 6;
      nextDiscountPercent = discounts[6];
      charmesNeeded = 6 - selected;
    }

    if (nextDiscountLevel && nextDiscountPercent > currentDiscount) {
      const discountDiff = nextDiscountPercent - currentDiscount;
      const charmesText = charmesNeeded === 1 ? '1 charm' : `${charmesNeeded} charms`;
      
      if (messageEl) {
        if (currentDiscount === 0) {
          messageEl.textContent = `Adicione mais ${charmesText} e ganhe ${nextDiscountPercent}% de desconto!`;
        } else {
          messageEl.textContent = `Adicione mais ${charmesText} e ganhe ${discountDiff.toFixed(0)}% de desconto adicional!`;
        }
      }
      this.charmsIncentive.style.display = 'flex';
    } else {
      this.charmsIncentive.style.display = 'none';
    }
  }

  calculateDiscount(charmsCount) {
    if (!this.settings.enableProgressiveDiscount) return 0;

    // Desconto progressivo configurável
    // 0-1 charm: 0% off (preço cheio)
    if (charmsCount <= 1) {
      return 0;
    }

    const discounts = this.settings.discounts;

    // Verificar descontos configuráveis
    if (charmsCount === 2) {
      return discounts[2] || 0;
    } else if (charmsCount === 3) {
      return discounts[3] || 0;
    } else if (charmsCount === 4) {
      return discounts[4] || 0;
    } else if (charmsCount === 5) {
      // Se tiver desconto específico para 5, usar. Senão, usar o de 4+
      return discounts[5] > 0 ? discounts[5] : (discounts[4] || 0);
    } else if (charmsCount >= 6) {
      // Se tiver desconto específico para 6+, usar. Senão, usar o anterior disponível
      if (discounts[6] > 0) {
        return discounts[6];
      } else if (discounts[5] > 0) {
        return discounts[5];
      } else {
        return discounts[4] || 0;
      }
    }

    return 0;
  }

  calculateTotal() {
    let subtotal = 0;

    // Base
    this.bundle.base.forEach(base => {
      if (base.product) {
        subtotal += base.product.price / 100;
      }
    });

    // Charms
    this.bundle.charms.forEach(charm => {
      if (charm.product) {
        subtotal += charm.product.price / 100;
      }
    });

    // Additional
    this.bundle.additional.forEach(item => {
      if (item.product) {
        subtotal += item.product.price / 100;
      }
    });

    // Desconto
    const charmsCount = this.bundle.charms.length;
    const discountPercent = this.calculateDiscount(charmsCount);
    const discount = subtotal * (discountPercent / 100);
    const total = subtotal - discount;

    // Cálculo do PIX
    const pixDiscountPercent = this.settings.pixDiscount;
    const pixMultiplier = 1.0 - (pixDiscountPercent / 100);
    const pixTotal = total * pixMultiplier;

    return {
      subtotal,
      discount,
      discountPercent,
      total,
      pixTotal,
      pixDiscountPercent
    };
  }

  updatePreview() {
    if (!this.preview) return;

    const pricing = this.calculateTotal();

    // Atualizar base
    this.updatePreviewBase();
    
    // Atualizar charms
    this.updatePreviewCharms();
    
    // Atualizar adicionais
    this.updatePreviewAdditional();
    
    // Atualizar preços
    this.updatePreviewPricing(pricing);
  }

  updatePreviewBase() {
    const baseContainer = this.preview.querySelector('[data-preview-base]');
    if (!baseContainer) return;

    if (this.bundle.base.length > 0) {
      baseContainer.innerHTML = `
        <div class="custom-bundle-preview__base-grid">
          ${this.bundle.base.map(base => {
            const product = base.product;
            return `
              <div class="custom-bundle-preview__base-thumb">
                <img
                  src="${product.featured_image || ''}"
                  alt="${product.title || ''}"
                  class="custom-bundle-preview__base-thumb-image"
                />
              </div>
            `;
          }).join('')}
        </div>
      `;
    } else {
      baseContainer.innerHTML = `
        <div class="custom-bundle-preview__empty-state">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="30" stroke="currentColor" stroke-width="2" stroke-dasharray="4 4"/>
            <path d="M32 20V32L40 36" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <p class="custom-bundle-preview__empty-text">Escolha um acessório</p>
        </div>
      `;
    }
  }

  updatePreviewCharms() {
    const charmsContainer = this.preview.querySelector('[data-charms-grid]');
    const charmsCountEl = this.preview.querySelector('[data-charms-count]');
    
    if (charmsCountEl) {
      charmsCountEl.textContent = `${this.bundle.charms.length} charms`;
    }

    if (!charmsContainer) return;

    if (this.bundle.charms.length > 0) {
      charmsContainer.innerHTML = this.bundle.charms.map(charm => {
        const product = charm.product;
        return `
          <div class="custom-bundle-preview__charm-item">
            <img 
              src="${product.featured_image || ''}" 
              alt="${product.title || ''}"
              class="custom-bundle-preview__charm-image"
            />
          </div>
        `;
      }).join('');
    } else {
      charmsContainer.innerHTML = `
        <div class="custom-bundle-preview__empty-state">
          <p class="custom-bundle-preview__empty-text">Adicione charms ao seu kit</p>
        </div>
      `;
    }
  }

  updatePreviewAdditional() {
    const additionalContainer = this.preview.querySelector('[data-additional-grid]');
    const additionalCountEl = this.preview.querySelector('[data-additional-count]');
    
    if (additionalCountEl) {
      additionalCountEl.textContent = `${this.bundle.additional.length} itens`;
    }

    if (!additionalContainer) return;

    if (this.bundle.additional.length > 0) {
      additionalContainer.innerHTML = this.bundle.additional.map(item => {
        const product = item.product;
        return `
          <div class="custom-bundle-preview__additional-item">
            <img 
              src="${product.featured_image || ''}" 
              alt="${product.title || ''}"
              class="custom-bundle-preview__additional-image"
            />
          </div>
        `;
      }).join('');
    } else {
      additionalContainer.innerHTML = `
        <div class="custom-bundle-preview__empty-state">
          <p class="custom-bundle-preview__empty-text">Adicione itens opcionais ao seu kit</p>
        </div>
      `;
    }
  }

  updatePreviewPricing(pricing) {
    const summaryContainer = this.preview.querySelector('[data-preview-summary]');
    const subtotalEl = this.preview.querySelector('[data-price-subtotal]');
    const discountEl = this.preview.querySelector('[data-price-discount]');
    const discountRow = this.preview.querySelector('[data-price-discount-row]');
    const totalEl = this.preview.querySelector('[data-price-total]');
    const pixEl = this.preview.querySelector('[data-price-pix]');

    // Verificar se há produtos no bundle (base ou charms)
    const hasProducts = this.bundle.base.length > 0 || this.bundle.charms.length > 0;

    // Mostrar/esconder container de preço
    if (summaryContainer) {
      if (hasProducts) {
        summaryContainer.style.display = 'flex';
      } else {
        summaryContainer.style.display = 'none';
        return; // Não atualizar valores se não há produtos
      }
    }

    if (subtotalEl) {
      subtotalEl.textContent = this.formatMoney(pricing.subtotal * 100);
    }

    if (pricing.discount > 0 && discountEl && discountRow) {
      discountEl.textContent = `-${this.formatMoney(pricing.discount * 100)}`;
      const discountPercentEl = this.preview.querySelector('[data-price-discount-percent]');
      if (discountPercentEl) {
        discountPercentEl.textContent = `(${pricing.discountPercent.toFixed(0)}%)`;
      }
      discountRow.style.display = 'flex';
    } else if (discountRow) {
      discountRow.style.display = 'none';
    }

    if (totalEl) {
      totalEl.textContent = this.formatMoney(pricing.total * 100);
    }

    if (pixEl && pricing.pixTotal) {
      pixEl.textContent = this.formatMoney(pricing.pixTotal * 100);
    }
  }

  updateStepper() {
    if (!this.stepperSteps) return;

    this.stepperSteps.forEach((step, index) => {
      const stepNumber = parseInt(step.dataset.stepNumber);
      step.classList.remove('is-active', 'is-completed');
      
      if (stepNumber === this.currentStep) {
        step.classList.add('is-active');
      } else if (stepNumber < this.currentStep) {
        step.classList.add('is-completed');
      }

      // Atualizar conector
      const connector = step.nextElementSibling;
      if (connector && connector.classList.contains('custom-bundle-stepper__connector')) {
        connector.classList.toggle('is-completed', stepNumber < this.currentStep);
      }
    });
  }

  goToStep(step) {
    // Validações
    if (step === 2 && this.bundle.base.length === 0) {
      this.showMessage('Por favor, selecione pelo menos um acessório antes de continuar.', 'warning');
      return;
    }

    if (step === 3 && this.settings.minCharms > 0 && this.bundle.charms.length < this.settings.minCharms) {
      this.showMessage(`Por favor, selecione pelo menos ${this.settings.minCharms} charms.`, 'warning');
      return;
    }

    // Atualizar step atual
    const currentStepEl = this.stepsContainer.querySelector(`[data-step="${this.currentStep}"]`);
    const nextStepEl = this.stepsContainer.querySelector(`[data-step="${step}"]`);

    if (currentStepEl) {
      currentStepEl.classList.remove('is-active');
    }

    if (nextStepEl) {
      nextStepEl.classList.add('is-active');
    }

    this.currentStep = step;
    this.updateStepper();
    this.updateStepActionsVisibility();

    // Scroll para topo
    this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Atualizar review se for step 4
    if (step === 4) {
      this.updateReview();
    }
  }

  updateStepActionsVisibility() {
    // Mostrar/ocultar botões de cada step baseado no step ativo
    Object.keys(this.stepActionsContainers).forEach(step => {
      const container = this.stepActionsContainers[step];
      if (container) {
        if (parseInt(step) === this.currentStep) {
          container.style.display = 'flex';
        } else {
          container.style.display = 'none';
        }
      }
    });
  }

  updateReview() {
    const pricing = this.calculateTotal();

    // Atualizar base no review
    this.updateReviewBase();
    
    // Atualizar charmes no review
    this.updateReviewCharms();
    
    // Atualizar adicionais no review
    this.updateReviewAdditional();
    
    // Atualizar preços no review
    this.updateReviewPricing(pricing);
  }

  updateReviewBase() {
    const baseContainer = this.container.querySelector('[data-review-base-item]');
    const baseCountEl = this.container.querySelector('[data-review-base-count]');
    const baseLabelEl = this.container.querySelector('[data-review-base-label]');

    const count = this.bundle.base.length;

    if (baseLabelEl) {
      baseLabelEl.textContent = count > 1 ? 'Pulseiras' : 'Pulseira';
    }

    if (baseCountEl) {
      baseCountEl.textContent = count > 0 ? `(${count})` : '';
    }

    if (!baseContainer) return;

    if (this.bundle.base.length > 0) {
      baseContainer.innerHTML = this.bundle.base.map(base => {
        const product = base.product;
        return `
          <div class="custom-bundle-step-review__item">
            <img
              src="${product.featured_image || ''}"
              alt="${product.title || ''}"
              class="custom-bundle-step-review__item-image"
            />
            <div class="custom-bundle-step-review__item-info">
              <p class="custom-bundle-step-review__item-title">${product.title || ''}</p>
              <p class="custom-bundle-step-review__item-price">${this.formatMoney(product.price)}</p>
            </div>
          </div>
        `;
      }).join('');
    } else {
      baseContainer.innerHTML = `
        <div class="custom-bundle-step-review__empty-state">
          <p>Nenhum acessório selecionado</p>
        </div>
      `;
    }
  }

  updateReviewCharms() {
    const charmsContainer = this.container.querySelector('[data-review-charms-grid]');
    const charmsCountEl = this.container.querySelector('[data-review-charms-count]');
    
    if (charmsCountEl) {
      charmsCountEl.textContent = `(${this.bundle.charms.length})`;
    }

    if (!charmsContainer) return;

    if (this.bundle.charms.length > 0) {
      charmsContainer.innerHTML = this.bundle.charms.map(charm => {
        const product = charm.product;
        return `
          <div class="custom-bundle-step-review__item">
            <img 
              src="${product.featured_image || ''}" 
              alt="${product.title || ''}"
              class="custom-bundle-step-review__item-image"
            />
            <div class="custom-bundle-step-review__item-info">
              <p class="custom-bundle-step-review__item-title">${product.title || ''}</p>
              <p class="custom-bundle-step-review__item-price">${this.formatMoney(product.price)}</p>
            </div>
          </div>
        `;
      }).join('');
    } else {
      charmsContainer.innerHTML = `
        <div class="custom-bundle-step-review__empty-state">
          <p>Nenhum charm selecionado</p>
        </div>
      `;
    }
  }

  updateReviewAdditional() {
    const additionalContainer = this.container.querySelector('[data-review-additional-grid]');
    const additionalCountEl = this.container.querySelector('[data-review-additional-count]');
    
    if (additionalCountEl) {
      additionalCountEl.textContent = `(${this.bundle.additional.length})`;
    }

    if (!additionalContainer) return;

    if (this.bundle.additional.length > 0) {
      additionalContainer.innerHTML = this.bundle.additional.map(item => {
        const product = item.product;
        return `
          <div class="custom-bundle-step-review__item">
            <img 
              src="${product.featured_image || ''}" 
              alt="${product.title || ''}"
              class="custom-bundle-step-review__item-image"
            />
            <div class="custom-bundle-step-review__item-info">
              <p class="custom-bundle-step-review__item-title">${product.title || ''}</p>
              <p class="custom-bundle-step-review__item-price">${this.formatMoney(product.price)}</p>
            </div>
          </div>
        `;
      }).join('');
    } else {
      additionalContainer.innerHTML = `
        <div class="custom-bundle-step-review__empty-state">
          <p>Nenhum item adicional selecionado</p>
        </div>
      `;
    }
  }

  updateReviewPricing(pricing) {
    const pricingContainer = this.container.querySelector('.custom-bundle-step-review__pricing');
    const subtotalEl = this.container.querySelector('[data-review-subtotal]');
    const discountEl = this.container.querySelector('[data-review-discount]');
    const discountRow = this.container.querySelector('[data-review-discount-row]');
    const totalEl = this.container.querySelector('[data-review-total]');
    const pixEl = this.container.querySelector('[data-review-pix]');

    // Verificar se há produtos no bundle (base ou charms)
    const hasProducts = this.bundle.base.length > 0 || this.bundle.charms.length > 0;

    // Mostrar/esconder container de preço
    if (pricingContainer) {
      if (hasProducts) {
        pricingContainer.style.display = 'flex';
      } else {
        pricingContainer.style.display = 'none';
        return; // Não atualizar valores se não há produtos
      }
    }

    if (subtotalEl) {
      subtotalEl.textContent = this.formatMoney(pricing.subtotal * 100);
    }

    if (pricing.discount > 0 && discountEl && discountRow) {
      discountEl.textContent = `-${this.formatMoney(pricing.discount * 100)}`;
      const discountPercentEl = this.container.querySelector('[data-review-discount-percent]');
      if (discountPercentEl) {
        discountPercentEl.textContent = `(${pricing.discountPercent.toFixed(0)}%)`;
      }
      discountRow.style.display = 'flex';
    } else if (discountRow) {
      discountRow.style.display = 'none';
    }

    if (totalEl) {
      totalEl.textContent = this.formatMoney(pricing.total * 100);
    }

    if (pixEl && pricing.pixTotal) {
      pixEl.textContent = this.formatMoney(pricing.pixTotal * 100);
    }
  }

  async fetchProductData(productHandle, variantId) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error('Produto não encontrado');
      }
      
      const product = await response.json();
      
      // Encontrar variant específico
      const variant = product.variants.find(v => v.id.toString() === variantId.toString());
      
      // Obter URL da imagem
      let featuredImage = '';
      if (variant && variant.featured_image) {
        featuredImage = variant.featured_image;
      } else if (product.featured_image) {
        featuredImage = product.featured_image;
      }
      
      return {
        id: product.id,
        title: product.title,
        price: variant ? variant.price : product.price,
        compare_at_price: variant ? variant.compare_at_price : product.compare_at_price,
        featured_image: featuredImage,
        variant: variant || product.variants[0]
      };
    } catch (error) {
      console.error('Erro ao buscar dados do produto:', error);
      return null;
    }
  }

  async addToCart() {
    if (this.bundle.base.length === 0) {
      this.showMessage('Por favor, selecione pelo menos um acessório.', 'error');
      return;
    }

    const addBtn = this.reviewAddBtn;
    const btnText = addBtn.querySelector('.custom-bundle-step-review__add-btn-text');
    const btnLoading = addBtn.querySelector('.custom-bundle-step-review__add-btn-loading');

    // Desabilitar botão e mostrar loading
    addBtn.disabled = true;
    if (btnText) btnText.style.display = 'none';
    if (btnLoading) btnLoading.style.display = 'flex';

    try {
      // Preparar itens para adicionar
      const items = [];

      // Base
      this.bundle.base.forEach(base => {
        items.push({
          id: base.variantId,
          quantity: 1
        });
      });

      // Charms
      this.bundle.charms.forEach(charm => {
        items.push({
          id: charm.variantId,
          quantity: 1
        });
      });

      // Additional
      this.bundle.additional.forEach(item => {
        items.push({
          id: item.variantId,
          quantity: 1
        });
      });

      // Adicionar ao carrinho
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Erro ao adicionar ao carrinho');
      }

      // Sucesso
      this.showMessage('Kit adicionado ao carrinho com sucesso!', 'success');

      // Atualizar carrinho se houver instância
      if (window.customCartDrawerInstance) {
        await window.customCartDrawerInstance.loadCart();
        window.customCartDrawerInstance.open();
      } else {
        // Recarregar página do carrinho ou atualizar contador
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }

      // Reset após sucesso (opcional)
      // this.reset();

    } catch (error) {
      console.error('Erro ao adicionar ao carrinho:', error);
      this.showMessage('Erro ao adicionar kit ao carrinho. Tente novamente.', 'error');
    } finally {
      // Reabilitar botão
      addBtn.disabled = false;
      if (btnText) btnText.style.display = 'block';
      if (btnLoading) btnLoading.style.display = 'none';
    }
  }

  formatMoney(cents) {
    // Formatação básica - pode ser melhorada com locale
    const value = cents / 100;
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(value);
  }

  showMessage(message, type = 'info') {
    // Criar elemento de mensagem
    const messageEl = document.createElement('div');
    messageEl.className = `custom-bundle-message custom-bundle-message--${type}`;
    messageEl.textContent = message;
    messageEl.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 16px 24px;
      background: ${type === 'error' ? '#f44336' : type === 'success' ? '#4caf50' : '#2196f3'};
      color: white;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      z-index: 10000;
      animation: slideIn 0.3s ease;
    `;

    document.body.appendChild(messageEl);

    // Remover após 3 segundos
    setTimeout(() => {
      messageEl.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => {
        document.body.removeChild(messageEl);
      }, 300);
    }, 3000);
  }

  reset() {
    this.bundle = {
      base: [],
      charms: [],
      additional: []
    };
    this.currentStep = 1;
    this.goToStep(1);
    this.updatePreview();
  }

  // ==================== SHARE FUNCTIONALITY ====================

  generateShareLink() {
    if (this.bundle.base.length === 0) {
      return null;
    }

    // Criar objeto com dados do bundle
    const bundleData = {
      base: this.bundle.base.map(b => b.variantId),
      charms: this.bundle.charms.map(c => c.variantId),
      additional: this.bundle.additional.map(a => a.variantId)
    };

    // Codificar em base64 para URL
    const encoded = btoa(JSON.stringify(bundleData));
    const currentUrl = window.location.origin + window.location.pathname;
    return `${currentUrl}?bundle=${encoded}`;
  }

  openShareModal() {
    if (!this.shareModal) return;

    const shareLink = this.generateShareLink();
    if (!shareLink) {
      this.showMessage('Complete o kit antes de compartilhar.', 'error');
      return;
    }

    if (this.shareLinkInput) {
      this.shareLinkInput.value = shareLink;
    }

    this.shareModal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  closeShareModal() {
    if (!this.shareModal) return;
    this.shareModal.style.display = 'none';
    document.body.style.overflow = '';
  }

  copyShareLink() {
    if (!this.shareLinkInput) return;

    this.shareLinkInput.select();
    this.shareLinkInput.setSelectionRange(0, 99999); // Para mobile

    try {
      document.execCommand('copy');
      this.showMessage('Link copiado para a área de transferência!', 'success');
      
      // Atualizar texto do botão temporariamente
      const originalText = this.shareCopyBtn.innerHTML;
      this.shareCopyBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M15 4.5L6.75 12.75L3 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Copiado!';
      setTimeout(() => {
        this.shareCopyBtn.innerHTML = originalText;
      }, 2000);
    } catch (err) {
      this.showMessage('Erro ao copiar link. Tente novamente.', 'error');
    }
  }

  shareOnWhatsApp() {
    const shareLink = this.generateShareLink();
    if (!shareLink) return;

    const text = encodeURIComponent('Confira o kit que montei na Charmit! 🎀✨');
    const url = `https://wa.me/?text=${text}%20${encodeURIComponent(shareLink)}`;
    window.open(url, '_blank');
  }

  shareOnFacebook() {
    const shareLink = this.generateShareLink();
    if (!shareLink) return;

    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareLink)}`;
    window.open(url, '_blank', 'width=600,height=400');
  }

  shareOnTwitter() {
    const shareLink = this.generateShareLink();
    if (!shareLink) return;

    const text = encodeURIComponent('Confira o kit que montei na Charmit! 🎀✨');
    const url = `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(shareLink)}`;
    window.open(url, '_blank', 'width=600,height=400');
  }

  async restoreBundleFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const bundleParam = urlParams.get('bundle');

    if (!bundleParam) return;

    try {
      // Decodificar dados do bundle
      const bundleData = JSON.parse(atob(bundleParam));

      // Restaurar base (suporta array e valor único para compatibilidade)
      const bases = Array.isArray(bundleData.base) ? bundleData.base : [bundleData.base];
      for (const baseVariantId of bases) {
        if (!baseVariantId) continue;
        const checkbox = this.container.querySelector(`[data-base-item] input[data-variant-id="${baseVariantId}"]`);
        if (checkbox) {
          checkbox.checked = true;
          await this.addBase(checkbox);
        }
      }

      // Restaurar charms
      if (bundleData.charms && bundleData.charms.length > 0) {
        for (const charmVariantId of bundleData.charms) {
          const checkbox = this.container.querySelector(`[data-charm-item] input[data-variant-id="${charmVariantId}"]`);
          if (checkbox) {
            checkbox.checked = true;
            await this.addCharm(checkbox);
          }
        }
      }

      // Restaurar itens adicionais
      if (bundleData.additional && bundleData.additional.length > 0) {
        for (const additionalVariantId of bundleData.additional) {
          const checkbox = this.container.querySelector(`[data-additional-item] input[data-variant-id="${additionalVariantId}"]`);
          if (checkbox) {
            checkbox.checked = true;
            await this.addAdditional(checkbox);
          }
        }
      }

      // Ir para o step de revisão
      this.goToStep(4);

      // Limpar URL
      window.history.replaceState({}, document.title, window.location.pathname);

      this.showMessage('Kit restaurado com sucesso!', 'success');
    } catch (error) {
      console.error('Erro ao restaurar bundle:', error);
    }
  }
}

// Inicializar quando DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
  const bundleBuilders = document.querySelectorAll('[data-bundle-builder]');
  bundleBuilders.forEach(container => {
    new BundleBuilder(container);
  });
});

// Suporte para seções dinâmicas do Shopify
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const bundleBuilder = event.target.querySelector('[data-bundle-builder]');
    if (bundleBuilder) {
      new BundleBuilder(bundleBuilder);
    }
  });
}
